<template>
  <modal-container>
    <modal-form-edit
      ref="ProfileFormModal"
      title="Profile"
      form-component="user-form"
      hide-delete-button
      on-close-clear-query
    >
      <template v-slot:underForm>
        <profile-change-email :user="user"/>

        <profile-change-password/>
      </template>

      <profile-notification-settings @openupgrademodal="openBillingPortal"/>

      <profile-one-click-settings/>

      <profile-email-signature/>

      <profile-end-of-day-report v-if="user.is_owner" :user="user"/>

      <profile-appointment-default :user="user"/>
    </modal-form-edit>
  </modal-container>
</template>

<script>
import localStorageService from "../../services/localStorage";
import ProfileChangeEmail from './components/ProfileChangeEmail';
import ProfileChangePassword from './components/ProfileChangePassword';
import ProfileEndOfDayReport from './components/ProfileEndOfDayReport';
import ProfileNotificationSettings from './components/ProfileNotificationSettings';
import ProfileAppointmentDefault from "./components/ProfileAppointmentDefault";
import ProfileEmailSignature from "./components/ProfileEmailSignature"
import ProfileOneClickSettings from "./components/ProfileOneClickSettings";

export default {
  name: "ProfileModal",
  components: {
    ProfileOneClickSettings,
    ProfileEmailSignature,
    ProfileChangeEmail,
    ProfileChangePassword,
    ProfileEndOfDayReport,
    ProfileNotificationSettings,
    ProfileAppointmentDefault
  },
  watch: {
    '$route' () {
      this.openModal();
    },
  },
  mounted() {
    this.openModal();
  },
  computed: {
    user() {
      return this.$store.getters.users.find(u => u.id === localStorageService.getAuthUser().id);
    },
  },
  methods: {
    openModal() {
      if (this.$route.query.modal === 'profile') {
        this.$refs.ProfileFormModal.open(this.user);
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
